export default {
  easyLanguage: 'Leichte Sprache',
  videoDoesNotYetExist: 'Video nicht gefunden'
}



// WEBPACK FOOTER //
// ./src/i18n/common/de.js